(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 55792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(23420);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dashboard; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/DashboardLayout/index.tsx + 6 modules
var DashboardLayout = __webpack_require__(79747);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/firebase/auth/FirebaseClaims.tsx
var FirebaseClaims = __webpack_require__(93598);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/frontend-utils/src/message/index.ts
var message = __webpack_require__(7476);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(81824);
// EXTERNAL MODULE: ../../node_modules/antd/es/tooltip/index.js + 5 modules
var es_tooltip = __webpack_require__(31136);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(58694);
// EXTERNAL MODULE: ../../libs/ui-components/src/lib/common/atoms/Typography/styles.tsx
var styles = __webpack_require__(93430);
// EXTERNAL MODULE: ../../node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(48562);
;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Dashboard/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  flex-direction: column;\n  padding: 36px;\n  overflow-y: auto;\n  z-index: 1;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 48px;\n\n  && {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  gap: 36px;\n  margin-top: 24px;\n  margin-bottom: 50px;\n  max-height: 600px;\n  height: 100%;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  max-width: 400px;\n  flex-direction: column;\n  border-radius: 18px;\n  background: ",
        ";\n  position: relative;\n  align-items: center;\n  justify-content: flex-end;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    font-size: 64px;\n    line-height: 120%;\n    color: ",
        ";\n  }\n  margin-top: 9px;\n  text-align: center;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 140%;\n  text-align: center;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 48px;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 210px;\n  display: flex;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n  background: url(",
        ") no-repeat center center;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  max-width: 400px;\n  .ant-skeleton-title {\n    border-radius: 18px;\n    height: 100%;\n    display: flex;\n    flex: 1;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}



const Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
const Heading = (0,styled_components_browser_esm/* default */.ZP)(styles/* Title */.Dx)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const Cards = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());
const Card = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
});
const PrimaryText = (0,styled_components_browser_esm/* default */.ZP)(styles/* Title */.Dx)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.blue60;
});
const Label = (0,styled_components_browser_esm/* default */.ZP)(styles/* Text */.xv)(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.grey100;
});
const CardBody = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6());
const ImageWrap = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), (param)=>{
    let { $src  } = param;
    return $src;
}, (param)=>{
    let { offsetY  } = param;
    return "background-position-y: ".concat(offsetY);
}, (param)=>{
    let { backgroundSize  } = param;
    return "background-size: ".concat(backgroundSize);
});
const SkeletonCard = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default */.Z).attrs({
    title: true,
    paragraph: false,
    active: true
})(_templateObject8());

;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Dashboard/DashboardCard.tsx




const DashboardCard = (param)=>{
    let { src , label , imageOffsetY , tooltip , children , loading , backgroundSize  } = param;
    const body = /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
        children: label
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonCard, {
        active: true,
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrap, {
                    $src: src,
                    offsetY: imageOffsetY,
                    backgroundSize: backgroundSize
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
                    children: [
                        tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_tooltip/* default */.Z, {
                            title: tooltip,
                            children: body
                        }) : body,
                        children
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../libs/data-access/src/generated/index.tsx + 5 modules
var generated = __webpack_require__(20229);
;// CONCATENATED MODULE: ../../libs/pages/src/vetter-platform/Dashboard/index.tsx







const Dashboard = (param)=>{
    let { userId  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const router = (0,next_router.useRouter)();
    const { data , loading  } = (0,generated/* useVetterDashboardQuery */.K1q)({
        variables: {
            userId
        },
        onError: ()=>{
            message/* message.error */.y.error("Failed to obtain information about your dashboard. Please, make sure your network is reliably working.");
        },
        onCompleted: (data)=>{
            var ref;
            if ((data === null || data === void 0 ? void 0 : (ref = data.vetterDashboard) === null || ref === void 0 ? void 0 : ref.__typename) === "User") {
                const { onboardingCompleted , approvalStatus  } = data.vetterDashboard;
                const isApproved = approvalStatus === "ACTIVE";
                if (!onboardingCompleted) {
                    router.replace("/terms");
                } else if (!isApproved) {
                    message/* message.destroy */.y.destroy();
                    message/* message.info */.y.info("You are on the waitlist to become a Vetter. We will inform you once your account is approved.", 0);
                }
            }
        }
    });
    const allVetsCount = data === null || data === void 0 ? void 0 : (ref = data.vetterDashboard) === null || ref === void 0 ? void 0 : ref.allVetsCount;
    const earnings = data === null || data === void 0 ? void 0 : (ref1 = data.vetterDashboard) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.stripeUser) === null || ref2 === void 0 ? void 0 : ref2.credit;
    const stripeUrl = data === null || data === void 0 ? void 0 : (ref3 = data.vetterDashboard) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.stripeUser) === null || ref4 === void 0 ? void 0 : ref4.stripeDashboardUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "dashboard-vetter",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                level: 1,
                children: "Dashboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Cards, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardCard, {
                        loading: loading,
                        label: "All-time Vettes",
                        src: "/images/illustration-vette.svg",
                        backgroundSize: "contain",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                            children: allVetsCount != null ? allVetsCount : "-"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardCard, {
                        loading: loading,
                        label: "This week's earnings",
                        src: "/images/illustration-earnings.svg",
                        tooltip: "Cash is transferred to Stripe account and available for withdrawal every Friday.",
                        backgroundSize: "contain",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryText, {
                            children: "$".concat(earnings != null ? earnings : 0)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardCard, {
                        loading: loading,
                        label: "More metrics",
                        src: "/images/stripe-logo.svg",
                        imageOffsetY: "70%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: stripeUrl !== null && stripeUrl !== void 0 ? stripeUrl : "/payouts",
                            target: stripeUrl ? "_blank" : undefined,
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                size: "large",
                                actionType: "primary",
                                children: stripeUrl ? "See directly in Stripe" : "Set up your Stripe account"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/dashboard/index.tsx





const dashboard_Dashboard = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseClaims/* FirebaseClaims */.h, {
            required: {
                id: true
            },
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
                loading: true
            }),
            children: (param)=>/*#__PURE__*/ {
                let { id  } = param;
                return (0,jsx_runtime.jsx)(DashboardLayout/* DashboardLayout */.c, {
                    hasStatusToggle: true,
                    overflowY: "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard, {
                        userId: id
                    })
                });
            }
        })
    });
};
/* harmony default export */ var dashboard = (dashboard_Dashboard);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [746,72,747,774,888,179], function() { return __webpack_exec__(55792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);